import { normalizeStudyTab } from './studyNavigation';

const pageLoaders = {
  'ai-tutor': () => import('../pages/ApTutorPage'),
  flashcards: () => import('../pages/ApFlashcardsPage'),
  'revision-tracker': () => import('../pages/ApCourseMapPage'),
};

const pendingLoads = new Map();

export function warmStudyRoute(tabId) {
  const normalizedTab = normalizeStudyTab(tabId);
  if (pendingLoads.has(normalizedTab)) return pendingLoads.get(normalizedTab);
  const loader = pageLoaders[normalizedTab];
  const pending = loader ? loader().catch((error) => {
    pendingLoads.delete(normalizedTab);
    throw error;
  }) : Promise.resolve(null);
  pendingLoads.set(normalizedTab, pending);
  return pending;
}
